import { render } from "./search-record-selection.vue?vue&type=template&id=1ef0c9df"
import script from "./search-record-selection.vue?vue&type=script&lang=js"
export * from "./search-record-selection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__